import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App/App';
import { reportError } from './services/errors';
import { loadingActions } from './redux/actions';
import { Store } from './redux/stores';
import meta from './meta';

import "./styles/fonts.css";
import "./styles/reset.css";
import "./styles/@mdi/font/css/materialdesignicons.min.css";
import "./styles/app.css";
import "./styles/sheet.css";
import "./styles/calendar.css";

console.originalError = console.error.bind(console);
console.errors = [];
console.error = (e, ...params) => {
    if (e && e.id) { 
        reportError(e);
        console.errors.push(e);
    }
    Store.dispatch(loadingActions.handleError(e));
    console.originalError(e, ...params);
}

window.addEventListener('error', (e) => {
    //reportError(e);
    Store.dispatch(loadingActions.handleError(e));
    return true;
});

let lastVersion = parseInt(localStorage.getItem('version') || "0");
let currentVersion = meta.buildDate || 1;

let dateVersion = new Date(lastVersion);
let version = `${String('0'+dateVersion.getDate()).substr(-2)}.${String('0'+(dateVersion.getMonth()+1)).substr(-2)}.${dateVersion.getFullYear()}`;


window.appVerion = version;

if (lastVersion !== currentVersion) {
    localStorage.setItem('version', currentVersion);
    window.location.reload(true);
}

ReactDOM.render(<App />, document.getElementById('root'));
